/* @flow */
import React from 'react';

import ErrorPage from 'views/ErrorPages/ErrorPage';
import { Dashboard } from 'views/Dashboard/Dashboard';
import { WelcomePage } from 'views/WelcomePage/WelcomePage';
import { allRoles } from 'permissions/general';
import type { RoleId } from 'permissions/defs';
import UserStore from 'stores/UserStore';
import { renderRoutes } from './RoutesUtilities';

// IMPORT ROUTES
import loginRoutes from './loginRoutes';
import formRoutes from './formRoutes';
import assetRoutes from './asset';
import accountRoutes from './account';
import contractRoutes from './contract';
import invoiceRoutes from './invoice';
import orderRoutes from './order';
import projectRoutes from './project';
import quoteRoutes from './quote';
import modelMastersRoutes from './modelMasters';
import productRoutes from './product';
import userRoutes from './user';
import manufacturer from './manufacturer';
import costCentre from './costCentre';
import notifications from './notifications';
import emailDomains from './emailDomains';
import reporting from './reporting';
import customerAccounts from './customerAccounts';
import { Redirect } from 'react-router-dom';

export const documentTitleTemplate = (title: string) => {
  const base = process.env.REACT_APP_SHORT_NAME;
  return `${base} | ${title}`;
};

const allRoutes = (roleId: RoleId) => [
  ...loginRoutes,
  ...formRoutes,
  ...assetRoutes,
  ...accountRoutes,
  ...contractRoutes,
  ...invoiceRoutes,
  ...orderRoutes,
  ...projectRoutes,
  ...quoteRoutes,
  ...modelMastersRoutes,
  ...productRoutes,
  ...userRoutes,
  ...manufacturer,
  ...costCentre,
  ...notifications,
  ...emailDomains,
  ...customerAccounts,
  ...reporting(roleId),

  // TODO: These should be refactored to more specific route files
  {
    path: '/',
    title: 'general:welcome_page.menu_item',
    component: function() {
      return <Redirect to={'/welcome-page'} />;
    },
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/welcome-page',
    title: 'general:welcome_page.menu_item',
    component: WelcomePage,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/welcome-page/modal/:modalType',
    component: WelcomePage,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/dashboard',
    title: 'general:dashboard',
    component: Dashboard,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/401',
    component: () => <ErrorPage code="401" />,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/404',
    component: () => <ErrorPage code="404" />,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/500',
    component: () => <ErrorPage code="500" />,
    exact: true,
    permissions: allRoles,
  },
];

export function renderMainRoutes(isUserSignedUp: Array<*>, userStore: UserStore) {
  return renderRoutes(
    {
      routes: allRoutes(userStore.userRoleId),
      loginRoutes,
      isUserSignedUp,
    },
    {
      userStore,
    }
  );
}

export function getRoutes(userStore: UserStore) {
  return allRoutes(userStore.userRoleId);
}
